<template>
    <div class="overall-bg mb-0">
        <b-container>
            <b-row>
                <b-col>
                    <BackToMasters :goback="$router.back" :flag="3"></BackToMasters>
                    <Headerlayout :headertext="$t('consigneePO.title')"
                        :contenttext="$t('userManagement.codeTemplate.content')" />
                </b-col>
            </b-row>
        </b-container>
    </div>

    <b-container class="form-white-bg">

        <b-row>
            <b-col>
                <b-tabs pills card class="suppliertabs" v-model="selectedTab">
                    <b-tab v-for="(item, index) in SupplierInfo" :key="index">

                        <template #title>
                            <p @click="SupplierOnClick(item, index)">
                                {{ item?.SupplierName }}
                                <span v-if="item?.IsServiceLevel == 0" class="servicelevel0">
                                    ({{ "Regular items" }})
                                </span>
                                <span v-if="item?.IsServiceLevel == 1" class="servicelevel1">
                                    ({{ "Service items" }})
                                </span>
                                <span v-if="item?.IsServiceLevel == 3" class="servicelevel3">
                                    ({{ "Asset items" }})
                                </span>
                                <span v-if="item?.IsServiceLevel == 4" class="servicelevel4">
                                    ({{ "Product items" }})
                                </span>
                                <span v-if="item?.IsServiceLevel == 5" class="servicelevel5">
                                    ({{ "Consignee items" }})
                                </span>
                            </p>
                        </template>

                        <b-row>
                            <b-col xl="6" lg="6" md="8" sm="12" cols="12" class="p-0">
                                <b-row class="p-3">
                                    <b-col lg="6" md="6" sm="6">
                                        <div class="field">
                                            <CustomDropdown :required-icon="false" label="Payment Terms"
                                                v-model="SupformData.PaymentTermsId" :rules="{ required: false }"
                                                name="Payment Terms" id="Payment Terms" :items="paymentTermsDropdown"
                                                @update:modelValue="PaymentTermsOnChange" />
                                        </div>
                                    </b-col>
                                    <b-col lg="6" md="6" sm="6">
                                        <div class="field">
                                            <CustomDropdown :required-icon="false" label="Delivery Terms"
                                                v-model="SupformData.DeliveryTermsId" :rules="{ required: false }"
                                                name="Delivery Terms" id="Delivery Terms" :items="deliveryTermsDropdown"
                                                @update:modelValue="DeliveryTermsOnChange" />
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <div class="SupplierCard">
                                            <div class="suppliercardcontent">
                                                <b-row class="p-3">
                                                    <b-col>
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <p class="supplieraddress">
                                                                {{ SupformData?.SupplierCode }}
                                                            </p>
                                                            <i class="pi pi-external-link"
                                                                style="color: #0a82ff; cursor: pointer"></i>
                                                        </div>
                                                        <h6>{{ SupformData?.SupplierName }}</h6>
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <p class="py-1 supplieraddress">
                                                                {{ SupformData?.SuplierAddress }}
                                                            </p>
                                                            <i class="pi pi-pencil" style="color: #3096ff"
                                                                @click="EditPaymentAndDeliveryTerms()"></i>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="p-3">
                                                    <b-col lg="6" sm="6">
                                                        <h6 class="header">
                                                            Payment Terms <span class="red">*</span>
                                                        </h6>
                                                        <div class="contentbg" :class="{
                                                            highlight: RequiredFields.paymentTermsHighlight,
                                                        }" v-if="!editPaymentDeliveryDetails">
                                                            <p>{{ POObj?.PaymentTermsName }}</p>
                                                        </div>
                                                        <div class="label-d-none field">
                                                            <Textarea v-model="POObj.PaymentTermsName"
                                                                v-if="editPaymentDeliveryDetails"
                                                                name="PaymentDeliveryTextarea" label=""
                                                                :rules="{ required: true }" id="PaymentDeliveryTextarea"
                                                                ref="PaymentDeliveryTextarea"
                                                                @blur="editPaymentDeliveryDetails = false" />
                                                        </div>
                                                    </b-col>

                                                    <b-col lg="6" sm="6">
                                                        <h6 class="header">
                                                            Delivery Terms <span class="red">*</span>
                                                        </h6>
                                                        <div class="contentbg" :class="{
                                                            highlight:
                                                                RequiredFields.deliveryTermsHighlight,
                                                        }" v-if="!editPaymentDeliveryDetails">
                                                            <p>{{ POObj?.DeliveryTermsName }}</p>
                                                        </div>
                                                        <div class="label-d-none field">
                                                            <Textarea v-model="POObj.DeliveryTermsName"
                                                                v-if="editPaymentDeliveryDetails"
                                                                name="PaymentDeliveryTextarea" label=""
                                                                :rules="{ required: false }"
                                                                id="PaymentDeliveryTextarea"
                                                                ref="PaymentDeliveryTextarea"
                                                                @blur="editPaymentDeliveryDetails = false" />
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                            <div class="SupplierCardgst p-3 mt-3">
                                                <b-row>
                                                    <b-col class="d-flex align-items-center">
                                                        <span>GST: {{ SupformData?.SupplierGSTNO }}</span>
                                                    </b-col>
                                                    <b-col class="d-flex flex-row-reverse">
                                                        <p class="mb-0">
                                                            <i ref="copyButton" class="pi pi-copy copyicon" v-b-tooltip="{
                                                                title: tooltipContent,
                                                                triggers: ['hover', 'focus'],
                                                            }" @click="copyGST"></i>
                                                        </p>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col xl="6" lg="6" md="8" sm="12" cols="12" class="p-3">
                                <b-row>
                                    <b-col lg="6" md="6" sm="6">
                                        <div class="field">
                                            <!-- {{StoreID}} -->
                                            <!-- <StoreDropDown label="Store" name="Store" id="Store" v-model="StoreDropdown.StoreId"
                                        :storetype="0" :filterId="StoreID"
                                        @update:modelValue="() => { SelectStore(StoreDropdown.StoreId), StoreOnChange() }"
                                        :rules="{ required: true }" :required-icon="true" /> -->

                                            <!-- Medway -->

                                            <StoreDropDown :label="$t('PO.POCreation.store')" name="Store" id="Store"
                                                v-model="StoreDropdown.StoreId" :filterId="SupformData?.FromStoreId"
                                                :rules="{ required: false }"
                                                @update:modelValue="() => { SelectStore(StoreDropdown.StoreId), StoreOnChange(StoreDropdown.StoreId?.Id) }"
                                                :required-icon="false" :storetype="0" :disabled="false" />

                                            <!-- Aravind -->
                                            <!-- <StoreDropDown :storeFilterStatus="2"  label="Store" name="Store" id="Store"
                                                v-model="StoreDropdown.StoreId" :filterId="SupformData?.FromStoreId"
                                                :rules="{ required: false }"
                                                @update:modelValue="() => { SelectStore(StoreDropdown.StoreId), StoreOnChange(StoreDropdown.StoreId?.Id) }"
                                                :required-icon="false" :disabled="false" /> -->

                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="12" cols="12" v-if="POObj.IsDraft == 0"
                                        class="d-flex flex-row-reverse covertedstatus">
                                        <GreenStatus name="Converted to PO" />
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <div class="d-flex align-items-center justify-content-between py-2">
                                            <p>Supplier Address <span class="red">*</span></p>
                                            <i class="pi pi-pencil" style="color: #3096ff"
                                                @click="EditSupplierAddressF()"></i>
                                        </div>
                                        <div class="contentbg" :class="{
                                            highlight: RequiredFields.SupplierAddressHighlight,
                                        }" v-if="!editSupplieraddress">
                                            <p>
                                                {{ SupformData?.SuplierAddress }}
                                            </p>
                                        </div>
                                        <div class="label-d-none field">
                                            <Textarea v-model="SupformData.SuplierAddress" v-if="editSupplieraddress"
                                                name="billingTextarea" label="" :rules="{ required: false }"
                                                id="billingTextarea" ref="billingTextarea"
                                                @blur="editSupplieraddress = false" />
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <div class="d-flex align-items-center justify-content-between py-2">
                                            <p>Billing Address <span class="red">*</span></p>
                                            <i class="pi pi-pencil" style="color: #3096ff"
                                                @click="EditBillAddress()"></i>
                                        </div>
                                        <div class="contentbg" :class="{
                                            highlight: RequiredFields.billingAddressHighlight,
                                        }" v-if="!editbillingaddress">
                                            <p>
                                                {{ SupformData?.SuplierBillingAddress }}
                                            </p>
                                        </div>
                                        <div class="label-d-none field">
                                            <Textarea v-model="SupformData.SuplierBillingAddress"
                                                v-if="editbillingaddress" name="billingTextarea" label=""
                                                :rules="{ required: false }" id="billingTextarea" ref="billingTextarea"
                                                @blur="editbillingaddress = false" />
                                        </div>
                                    </b-col>
                                </b-row>

                                <b-row class="my-0">
                                    <b-col>
                                        <div class="d-flex align-items-center justify-content-between py-2">
                                            <p>Delivery Address <span class="red">*</span></p>
                                            <i class="pi pi-pencil" style="color: #3096ff"
                                                @click="EditDeliveryAddress()"></i>
                                        </div>
                                        <div class="contentbg" :class="{
                                            highlight: RequiredFields.deliveryAddressHighlight,
                                        }" v-if="!editdeliaddress">
                                            <p>
                                                {{ SupformData?.SuplierDeliveryAddress }}
                                            </p>
                                        </div>
                                        <div class="label-d-none field">
                                            <Textarea v-model="SupformData.SuplierDeliveryAddress"
                                                v-if="editdeliaddress" name="deliveryTextarea" label=""
                                                :rules="{ required: false }" id="deliveryTextarea"
                                                ref="deliveryTextarea" @blur="editdeliaddress = false" />
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="6" md="6" sm="6" cols="12">
                                <div class="field">
                                    <TextArea name="AdditionalTerms" label="Additional terms"
                                        :rules="{ required: false }" id="Additional terms"
                                        v-model="SupformData.AdditionalTerms" />
                                </div>
                            </b-col>
                            <b-col lg="6" md="6" sm="6" cols="12">
                                <div class="field">
                                    <TextArea name="Reference" label="Reference" :rules="{ required: false }"
                                        id="Reference" v-model="SupformData.Reference" />
                                </div>
                            </b-col>
                        </b-row>

                        <b-row class="my-3">
                            <b-col lg="3" md="3" sm="3" cols="12">
                                <p class="blue-txt" v-b-toggle.collapse-1>
                                    + Add transport charges
                                </p>
                                <b-collapse id="collapse-1">
                                    <div class="field">
                                        <TextField :required-icon="false" name="TransportCharges" id="TransportCharges"
                                            label="" :rules="{ required: false, decimal: true }"
                                            v-model="POObj.TransportCharges"
                                            @update:modelValue="TransportChargesOnChange" />
                                    </div>
                                </b-collapse>
                            </b-col>
                            <b-col lg="3" md="3" sm="3" cols="12">
                                <p class="blue-txt" v-b-toggle.collapse-2>
                                    + Add other charges
                                </p>
                                <b-collapse id="collapse-2">
                                    <div class="field">
                                        <TextField :required-icon="false" name="OtherCharges" id="OtherCharges" label=""
                                            :rules="{ required: false, decimal: true }" v-model="POObj.OtherCharges"
                                            @update:modelValue="OtherChargesOnChange" />
                                    </div>
                                </b-collapse>
                            </b-col>
                            <b-col lg="3" md="3" sm="3" cols="12">
                                <p class="blue-txt" v-b-toggle.collapse-3>+ Add discount</p>
                                <b-collapse id="collapse-3">
                                    <div class="field">
                                        <TextField :required-icon="false" name="DiscountAmount" id="DiscountAmount"
                                            label="" :rules="{ required: false, decimal: true }"
                                            v-model="POObj.DiscountAmount"
                                            @update:modelValue="DiscountAmountOnChange" />
                                    </div>
                                </b-collapse>
                            </b-col>
                            <b-col lg="3" md="3" sm="3" cols="12"
                                class="d-flex align-items-center justify-content-end px-3">
                                <div class="totaldiv1">
                                    <p class="component-heading mb-0">{{ ItemTable.length }}</p>
                                    <p class="light-txt">Items</p>
                                </div>
                                <div class="totaldiv2">
                                    <p class="component-heading mb-0">
                                        <span class="pe-1">₹ {{ sumOfRates }}</span>
                                    </p>
                                    <p class="light-txt">Value</p>
                                </div>
                            </b-col>


                        </b-row>

                        <b-row class="mb-4">
                            <b-col lg="12" cols="12">
                                <!-- {{ ItemTable }} -->
                                <NormalTable :rowHover="true" filterDisplay="menu" responsiveLayout="scroll"
                                    :columns="POheaders" v-model:value="ItemTable" :seriaNlumber=true>
                                    <template v-slot:Brandmodelsize="{ data }">
                                        <p><span v-if="data.BrandName">{{ data.BrandName }} </span><span
                                                v-if="data.ModelNumberName"> / {{
                                                    data.ModelNumberName }} </span><span v-if="data.SizeName"> / {{
                                                    data.SizeName }}</span></p>
                                    </template>

                                    <template v-slot:action="{ data }">
                                        <div class="d-flex align-items-center">
                                            <!-- <EditIcon @click="IsItemEdit(data)" />
                                            <DeleteIcon @click="IsItemDelete(data)" /> -->
                                            <Button @click="visible = true, getSupplierDetailsItemId(data)"
                                                icon="pi pi-info-circle"
                                                class="p-button-rounded editicon p-button-text" />
                                        </div>
                                    </template>

                                    <template v-slot:TempTaxSlot="{ data }">
                                        <div class="label-d-none tablefield mb-0">
                                            <Dropdown :options="TempTaxOption" v-model="data.PurchasePercentage"
                                                :disabled="false" @change="TempTaxOnChange(data)" :show-clear="false"
                                                optionLabel="name" optionValue="value" />
                                        </div>
                                    </template>

                                </NormalTable>
                            </b-col>
                            <b-col lg="12" cols="12" v-if="POObj.IsDraft == 1">
                                <Footer @cancel="" @save="IsSubmit" :cancelhide="false" :label="label" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="8" md="8">
                            </b-col>
                            <b-col lg="4" md="4">
                                <b-row>
                                    <b-col class="ammount_footer">
                                        <p class="light-txt">
                                            Gross Amount
                                        </p>
                                        <p>
                                            <span class="pe-1">&#8377</span>
                                            {{ POCalcDetails.GrossAmount }}
                                        </p>
                                    </b-col>

                                </b-row>


                                <b-row>
                                    <b-col class="ammount_footer">
                                        <p class="light-txt">
                                            SGST Amount
                                        </p>
                                        <p>
                                            <span class="pe-1">&#8377</span>
                                            {{ POCalcDetails.SGSTTaxAmount }}
                                        </p>
                                    </b-col>

                                </b-row>

                                <b-row>
                                    <b-col class="ammount_footer">
                                        <p class="light-txt">
                                            CGST Amount
                                        </p>
                                        <p>
                                            <span class="pe-1">&#8377</span>
                                            {{ POCalcDetails.CGSTTaxAmount }}
                                        </p>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="ammount_footer">
                                        <p class="light-txt">
                                            IGST Amount
                                        </p>
                                        <p>
                                            <span class="pe-1">&#8377</span>
                                            {{ POCalcDetails.IGSTTaxAmount }}
                                        </p>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="ammount_footer">
                                        <p class="light-txt">
                                            Tax Amount
                                        </p>
                                        <p>
                                            <span class="pe-1">&#8377</span>
                                            {{ POCalcDetails.TaxAmount }}
                                        </p>
                                    </b-col>

                                </b-row>
                                <b-row>
                                    <b-col class="ammount_footer">
                                        <p class="light-txt">
                                            Transport charges
                                        </p>
                                        <p>
                                            <span class="pe-1">&#8377</span>
                                            {{ POCalcDetails.Transportcharges }}
                                        </p>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="ammount_footer">
                                        <p class="light-txt">
                                            Other charges
                                        </p>
                                        <p>
                                            <span class="pe-1">&#8377</span>
                                            {{ POCalcDetails.Othercharges }}
                                        </p>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="ammount_footer">
                                        <p class="light-txt">
                                            Discount Amount
                                        </p>
                                        <p>
                                            <span class="pe-1">&#8377</span>
                                            {{ POCalcDetails.DiscountAmount }}
                                        </p>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col class="d-flex align-items-center mt-5">
                                        <p>
                                            Grand Total
                                        </p>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col offset-lg="3" class="d-flex px-0">
                                        <div class="totaldiv1">
                                            <p class="component-heading">{{ POCalcDetails.ItemCount }}</p>

                                            <p class="light-txt">Items Part of this PO</p>
                                        </div>
                                        <div class="totaldiv2">
                                            <p class="component-heading"><span class="pe-1">&#8377</span>{{
                                                POCalcDetails.TotalAmount }}</p>
                                            <p class="light-txt mt-3">{{ $t('grn.value') }}</p>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
    </b-container>
    <Dialog :modal="true" v-model:visible="visible" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
        :style="{ width: '65vw' }" header="Item Info" @after-hide="visible = false">

        <Tableview :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="Iteminfoheaders"
            :data="supplierDetailsList" :selectionMode="false">
            <template v-slot:Add>
                <span>
                    <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                </span>
            </template>

        </Tableview>
    </Dialog>
    <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
    <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />

    <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import BackToMasters from "../../../../../components/FormComponents/BacktoMaster.vue";
import CustomDropdown from "../../../../../components/FormComponents/Dropdown.vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import SupplierComponent from "../../../../../modules/Inventory/components/Transaction/SupplierComponent.vue";
import TextArea from "../../../../../components/FormComponents/TextArea.vue";
import NormalTable from "../../../../../components/FormComponents/NormalTable.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import WithoutStockService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";
import SupplierService from "../../../../../modules/Inventory/Service/SupplierMaster";
import moment from "moment";
import { useToast } from "primevue/usetoast";
import CreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import PaymentTermsService from "../../../../../modules/Inventory/Service/PaymentTermsService";
import DeliveryTermsService from "../../../../../modules/Inventory/Service/DeliveryTermsService";
import StoreService from "../../../../../modules/Inventory/Service/StoreService";
import StoreDropDown from "../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";

import Tableview from "../../../../../components/FormComponents/NormalTable.vue";

import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";

import { useConsigneeStore } from "../../../../../modules/Inventory/stores/ConsigneePOStore";

export default defineComponent({
    components: {
        Tableview,
        BackToMasters,
        CustomDropdown,
        Headerlayout,
        SupplierComponent,
        TextArea,
        NormalTable,
        Footer,
        CreateSuccessully,
        UpdatedSuccessfully,
        TextField,
        StoreDropDown
    },

    setup() {
        const tooltipContent = ref("Copy GST");
        let useConsigneePOStore = useConsigneeStore();

        const router = useRouter();
        const route = useRoute();

        const selectedProduct = ref([]);
        let label = ref("Submit");

        const QueryStringValue = useRoute();
        const toast = useToast();

        let ItemTable: any = ref([]);
        let HiddenItemTable: any = ref([]);
        let SupplierInfo: any = ref([]);
        let currentDate = new Date().toISOString().slice(0, 10);
        let POId = 0;
        var arr: any = [];
        const successpop = ref(false);
        const updatepop = ref(false);
        let editSupplieraddress = ref(false);
        let editbillingaddress = ref(false);
        let editdeliaddress = ref(false);
        let editPaymentDeliveryDetails = ref(false);

        let paymentTermsDropdown = ref();
        let deliveryTermsDropdown = ref();
        const selectedTab = ref(0);
        let sumOfRates = ref("00.0");

        let RequiredFields = ref({
            paymentTermsHighlight: false,
            deliveryTermsHighlight: false,
            SupplierAddressHighlight: false,
            billingAddressHighlight: false,
            deliveryAddressHighlight: false,
        });

        const POCalcDetails: any = ref({
            GrossAmount: 0.00,
            TaxAmount: 0.00,
            SGSTTaxAmount: 0.00,
            CGSTTaxAmount: 0.00,
            IGSTTaxAmount: 0.00,
            Transportcharges: 0.00,
            Othercharges: 0.00,
            DiscountAmount: 0.00,
            ItemCount: 0,
            TotalAmount: 0.00
        })

        let session: any = localStorage.getItem("UsersData");
        session = JSON.parse(session);
        let PoIdsList: any = localStorage.getItem("ConsigneePoIdList");
        PoIdsList = JSON.parse(PoIdsList).join();


        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }

        const POheaders = [

            {
                header: "Category",
                field: "ItemCategory1",
                class: "smallwidth",
            },
            {
                header: "Code",
                field: "ItemProductId",
                class: "smallwidth",

            },

            {
                header: "Name",
                field: "Itemname1",
                bodyclass: "boldclass text_overflow2",
                class: "mediumwidth",
            },
            {
                header: "Brand / Model / Size",
                field: "",
                slot: "Brandmodelsize",
                fieldDisplay: "false",
            },

            {
                header: "Avl Qty",
                field: "StockInHand",
                bodyclass: "right_td",
                class: "smallwidth"

            },
            {
                header: "Unit Rate",
                field: "UnitRate",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "Qty",
                field: "ItemQuantity",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "Rate",
                field: "Rate",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            // {
            //     header: "Tax %",
            //     field: "PurchasePercentage",
            //     bodyclass: "right_td",
            //     class: "smallwidth"
            // },
            {
                header: "Tax %",
                field: "PurchasePercentage",
                bodyclass: "right_td",
                class: "smallwidth",
                slot: "TempTaxSlot",
                fieldDisplay: "false",
            },
            {
                header: "Tax",
                field: "Purchasetaxamount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "SGST %",
                field: "SGSTTax",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "SGST",
                field: "SGSTTaxAmount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "CGST %",
                field: "CGSTTax",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "CGST",
                field: "CGSTTaxAmount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "IGST %",
                field: "IGSTTax",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "IGST",
                field: "IGSTTaxAmount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                header: "Total",
                field: "Amount",
                bodyclass: "right_td",
                class: "smallwidth"
            },
            {
                class: "filterdisplaynone last-column-position",
                fieldDisplay: "false",
                field: "action",
                header: "",
                slot: "action",
                frozencolumn: true,
                sortable: false,
            },
        ];

        const POObj = ref({
            Id: 0,
            DocType: "",
            DocNo: "",
            RefId: 0,
            RefNo: "",
            SupplierId: 0,
            DocDate: ref(),
            FromStore: 0,
            ToStore: 0,
            HospitalId: 0,
            BranchId: 0,
            CreatedAt: currentDate,
            StoreId: 0,

            ModifiedAt: "",
            ModifiedBy: 0,
            CreatedBy: 0,
            EntityId: 0,
            EntityOperationId: 0,
            DeptRoleId: 0,
            IsServiceLevel: 0,
            SupplierAddress: "",
            BillingAddress: "",
            DeliveryAddress: "",
            AdditionalTerms: "",
            Reference: "",
            PaymentTermsName: "",
            DeliveryTermsName: "",
            IsDraft: 0,

            TaxAmount: 0.00,
            SGSTTaxAmount: 0.00,
            CGSTTaxAmount: 0.00,
            IGSTTaxAmount: 0.00,
            TransportCharges: "0.00",
            OtherCharges: "0.00",
            DiscountAmount: "0.00",
            Amount: 0.00,

            StoreBrMapId: 0,
            FromStoreBrMapId: 0,
            ToStoreBrMapId: 0,
            FromStoreBranchId: 0,
            ToStoreBranchId: 0
        });

        const SupformData = ref({
            ToStoreName: "",
            FromStoreId: 0,
            ToStoreId: 0,
            SupplierCode: "",
            SupplierName: "",
            SupplierGSTNO: "",
            SuplierAddress: "",
            SuplierBillingAddress: "",
            SuplierDeliveryAddress: "",
            SuplierCity: "",
            SuplierState: "",
            SuplierCountry: "",
            PaymentTermsId: ref(),
            DeliveryTermsId: ref(),
            AdditionalTerms: "",
            Reference: "",
        });

        let calcValues = ref({
            grossamount: 0.0,
        });

        const copyButton = document.querySelector(".pi-copy");
        if (copyButton) {
            copyButton.addEventListener("focus", () => {
                tooltipContent.value = "Click to copy";
            });
            copyButton.addEventListener("mouseleave", () => {
                tooltipContent.value = "Copy GST";
            });
        }

        onMounted(() => {
            debugger;
            ReadyFunction();
        });

        async function ReadyFunction() {
            debugger;
            await loadPaymentTerms();
            await loadDeliveryTerms();
            IsShowPOByPOId();
        }

        async function IsShowPOByPOId() {
            debugger;
            const response = await WithoutStockService.GetByStockWOTransByMultipleId(
                PoIdsList
            );

            POObj.value.StoreBrMapId = response["result"][0].StoreBrMapId
            POObj.value.FromStoreBrMapId = response["result"][0].FromStoreBrMapId
            POObj.value.ToStoreBrMapId = response["result"][0].ToStoreBrMapId

            POObj.value.FromStoreBranchId = response["result"][0].FromStoreBranchId
            POObj.value.ToStoreBranchId = response["result"][0].ToStoreBranchId

            HiddenItemTable.value = response["result"];
            SupplierInformation();
        }

        // function SupplierInformation() {
        //     debugger;
        //     const supplierRowCount = {};
        //     HiddenItemTable.value.forEach((item) => {
        //         const supplierId = item.SupplierId;
        //         if (supplierId) {
        //             if (!supplierRowCount[supplierId]) {
        //                 supplierRowCount[supplierId] = {
        //                     SupplierName: item.SupplierName,
        //                     SupplierId: item.SupplierId,
        //                     StockWOTransId: item.StockWOTransId,
        //                 };
        //             }
        //         }
        //     });

        //     // Convert supplierRowCount object to an array of supplier counts
        //     SupplierInfo.value = Object.values(supplierRowCount);

        //     console.log("SupplierInfo", SupplierInfo.value);

        //     SupplierOnClick(SupplierInfo.value[0], 0);
        // }

        async function SupplierInformation() {
            debugger;
            const supplierRowCount = {};
            HiddenItemTable.value.forEach((item) => {
                const StockWOTransId = item.StockWOTransId;
                if (StockWOTransId) {
                    if (!supplierRowCount[StockWOTransId]) {
                        supplierRowCount[StockWOTransId] = {
                            SupplierName: item.SupplierName,
                            SupplierId: item.SupplierId,
                            StockWOTransId: item.StockWOTransId,
                            IsServiceLevel: item.IsServiceLevel,
                        };
                    }
                }
            });

            // Convert supplierRowCount object to an array of supplier counts
            SupplierInfo.value = Object.values(supplierRowCount);

            console.log("SupplierInfo", SupplierInfo.value);

            await SupplierOnClick(SupplierInfo.value[0], 0);
        }

        function mergeDuplicates(arr) {
            const map = new Map();

            arr.forEach(item => {
                if (map.has(item.StockDetailsId)) {
                    // Customize how you want to merge the objects here
                    const existing = map.get(item.StockDetailsId);
                    map.set(item.StockDetailsId, { ...existing, ...item });
                } else {
                    map.set(item.StockDetailsId, item);
                }
            });

            return Array.from(map.values());
        }
        async function SupplierOnClick(item, index) {
            debugger;
            SupformData.value.PaymentTermsId = null;
            SupformData.value.DeliveryTermsId = null;
            StoreDropdown.value.StoreId = null;
            POObj.value.PaymentTermsName = "";
            POObj.value.DeliveryTermsName = "";
            POObj.value.TransportCharges = "0.00";
            POObj.value.OtherCharges = "0.00";
            POObj.value.DiscountAmount = "0.00";

            selectedTab.value = index;

            await GetSupplierInfo(item.SupplierId);

            let regex = new RegExp(item.SupplierId, "i");
            ItemTable.value = HiddenItemTable.value.filter((f) =>
                regex.test(f.SupplierId) &&
                f.SupplierId == item.SupplierId
            );
            ItemTable.value = ItemTable.value.map((item) => {

                item.Rate = Number(item.Rate).toFixed(2)

                item.Purchasetaxamount = Number((item.PurchasePercentage * item.Rate) / 100).toFixed(2)

                if (session.BranchStateId != SupformData.value.SuplierState) {
                    item.SGSTTax = 0
                    item.SGSTTaxAmount = 0.00

                    item.CGSTTax = 0
                    item.CGSTTaxAmount = 0.00

                    item.IGSTTax = Number(item.PurchasePercentage)
                    item.IGSTTaxAmount = Number((item.PurchasePercentage * item.Rate) / 100).toFixed(2)
                }
                else {
                    item.SGSTTax = Number(item.PurchasePercentage) / 2
                    item.SGSTTaxAmount = Number(Number(item.Purchasetaxamount) / 2).toFixed(2)

                    item.CGSTTax = Number(item.PurchasePercentage) / 2
                    item.CGSTTaxAmount = Number(Number(item.Purchasetaxamount) / 2).toFixed(2)

                    item.IGSTTax = 0
                    item.IGSTTaxAmount = 0.00
                }

                item.Amount = Number(Number(item.Rate) + Number(item.SGSTTaxAmount) +
                    Number(item.CGSTTaxAmount) + Number(item.IGSTTaxAmount)).toFixed(2)

                return item
            });

            // Summing all the "Rate" fields in the ItemTable.value array
            sumOfRates.value = ItemTable.value.reduce((total, currentItem) => {
                return total + currentItem.ItemRate;
            }, 0);

            POId = item.StockWOTransId;

            await PoEdit();
            await GetStoresByUserId();
            await GetStoresByStoreId();
            StoreOnChange(SupformData.value.ToStoreId);
        }

        async function GetSupplierInfo(SupplierId) {
            debugger;

            const response = await SupplierService.EditData(SupplierId);
            console.log(response["result"]);

            SupformData.value.SupplierCode = response["result"][0].Code;
            SupformData.value.SupplierName = response["result"][0].Name;

            if (POObj.value.IsDraft != 0) {
                POObj.value.PaymentTermsName = response["result"][0].PaymentTermsDesc;
                POObj.value.DeliveryTermsName = response["result"][0].DeliTermsDesc;
            }

            SupformData.value.SupplierGSTNO = response["result"][0].GSTNO;
            SupformData.value.SuplierAddress = response["result"][0].AddressVar;
            SupformData.value.SuplierState = response["result"][0].State;

            SupformData.value.AdditionalTerms = response["result"][0].AdditionalTerms;
            SupformData.value.Reference = response["result"][0].Reference;
        }

        async function PoEdit() {
            try {
                debugger;
                const response = await WithoutStockService.GetByStockWOTransId(POId);
                let data = response["result"];

                Object.keys(POObj.value).forEach((key) => {
                    if (data[0][key]) POObj.value[key] = data[0][key];
                });

                Object.keys(calcValues.value).forEach((key) => {
                    if (data[0][key]) calcValues.value[key] = data[0][key];
                });

                SupformData.value.FromStoreId = data[0].FromStore;

                SupformData.value.ToStoreId = data[0].ToStore;

                SelectToStore.value = data[0].ToStoreBrMapId;

                SupformData.value.ToStoreName = data[0].ToStoreName;

                POObj.value.IsDraft = data[0].IsDraft;

                POObj.value.IsServiceLevel = Number(data[0].IsServiceLevel);

                console.log(POObj.value);
            } catch (error) {
                alert(error);
            }
        }

        const StoreDropdown: any = ref({
            StoreOptions: [],
            StoreId: ref(),
        });

        async function GetStoresByUserId() {
            debugger;
            // const result = await StoreService.getStoreListByUserId(
            //     session.UserId,
            //     session.OrganizationId,
            //     session.Admin,
            //     POObj.value.FromStoreBranchId
            //     // Number(QueryStringValue.query.BranchId)
            // );
            const result = await StoreService.StoreDropDownListByUserId(
                session.UserId,
                session.OrganizationId,
                session.Admin,
                POObj.value.FromStoreBranchId
                // Number(QueryStringValue.query.BranchId)
            );

            if (result["result"].length > 0) {
                let StoreData = result["result"].find(
                    (item) => item.Id == SupformData.value.FromStoreId
                );

                SupformData.value.SuplierBillingAddress = StoreData?.BranchAddress;
                RequiredFields.value.billingAddressHighlight = false;
            }
        }

        async function GetStoresByStoreId() {
            debugger;
            const result = await StoreService.getStoreByStoreId(
                SupformData.value.FromStoreId,
                session.OrganizationId,
                POObj.value.ToStoreBranchId
                // Number(QueryStringValue.query.BranchId)
            );
            StoreDropdown.value.StoreOptions = result["result"].map((item) => {
                item.name = item.Name;
                item.value = item.Id;
                return item;
            });
        }

        function StoreOnChange(value) {
            debugger;
            if (value != null && value != undefined) {
                let StoreData = StoreDropdown.value.StoreOptions.find(
                    (item) => item.Id == value && item.StoreBranchMapId == SelectToStore.value
                );

                SupformData.value.SuplierDeliveryAddress = StoreData?.BranchAddress;
                RequiredFields.value.deliveryAddressHighlight = false;
            }
        }

        let SelectToStore = ref(0);

        function SelectStore(value) {
            debugger
            if (value) {
                SelectToStore.value = value.StoreBranchMapId

                POObj.value.ToStore = value.StoreId
                POObj.value.ToStoreBranchId = value.BranchId
                POObj.value.ToStoreBrMapId = value.StoreBranchMapId
            }
        }

        function RequiredFieldFunction() {
            if (
                SupformData.value.SuplierAddress == "" ||
                SupformData.value.SuplierAddress == null
            ) {
                RequiredFields.value.SupplierAddressHighlight = true;
            }
            else if (
                SupformData.value.SuplierBillingAddress == "" ||
                SupformData.value.SuplierBillingAddress == null
            ) {
                RequiredFields.value.billingAddressHighlight = true;
            } else if (
                SupformData.value.SuplierDeliveryAddress == "" ||
                SupformData.value.SuplierDeliveryAddress == null
            ) {
                RequiredFields.value.deliveryAddressHighlight = true;
            } else if (
                POObj.value.PaymentTermsName == "" ||
                POObj.value.PaymentTermsName == null
            ) {
                RequiredFields.value.paymentTermsHighlight = true;
            } else if (
                POObj.value.DeliveryTermsName == "" ||
                POObj.value.DeliveryTermsName == null
            ) {
                RequiredFields.value.deliveryTermsHighlight = true;
            }

            toast.add({
                severity: "warn",
                summary: "Please Fill in Required Fields: ",
                detail: "Terms and Address",
                life: 3000,
            });
        }

        watch(ItemTable, (newItems, oldItems) => {
            debugger;
            if (ItemTable.value.length > 0) {
                pocalculation();

            }
        }, { deep: true });

        const pocalculation = () => {
            debugger;
            POCalcDetailsClear()
            for (let i = 0; i < ItemTable.value.length; i++) {

                POCalcDetails.value.GrossAmount += parseFloat(ItemTable.value[i]["Rate"]);
                POCalcDetails.value.TaxAmount += parseFloat(ItemTable.value[i]["Purchasetaxamount"]);

                if (session.BranchStateId != SupformData.value.SuplierState) {
                    POCalcDetails.value.SGSTTaxAmount = 0.00;
                    POCalcDetails.value.CGSTTaxAmount = 0.00;
                    POCalcDetails.value.IGSTTaxAmount += parseFloat(ItemTable.value[i]["IGSTTaxAmount"]);
                }
                else {
                    POCalcDetails.value.SGSTTaxAmount += parseFloat(ItemTable.value[i]["SGSTTaxAmount"]);
                    POCalcDetails.value.CGSTTaxAmount += parseFloat(ItemTable.value[i]["CGSTTaxAmount"]);
                    POCalcDetails.value.IGSTTaxAmount = 0.00;
                }
            }

            POCalcDetails.value.GrossAmount = Number(POCalcDetails.value.GrossAmount).toFixed(2);
            POCalcDetails.value.TaxAmount = Number(POCalcDetails.value.TaxAmount).toFixed(2);
            POCalcDetails.value.SGSTTaxAmount = Number(POCalcDetails.value.SGSTTaxAmount).toFixed(2);
            POCalcDetails.value.CGSTTaxAmount = Number(POCalcDetails.value.CGSTTaxAmount).toFixed(2);
            POCalcDetails.value.IGSTTaxAmount = Number(POCalcDetails.value.IGSTTaxAmount).toFixed(2);

            poSubcalculation()
        };

        const poSubcalculation = () => {
            debugger;
            if (ItemTable.value.length > 0) {
                POCalcDetails.value.ItemCount = ItemTable.value.length;
                // POCalcDetails.value.TotalAmount = Number(((Number(POCalcDetails.value.GrossAmount) + Number(POCalcDetails.value.TaxAmount) + Number(POCalcDetails.value.Transportcharges) + Number(POCalcDetails.value.Othercharges)) - Number(POCalcDetails.value.DiscountAmount)).toFixed(2));

                POCalcDetails.value.TotalAmount = ((Number(POCalcDetails.value.GrossAmount) + Number(POCalcDetails.value.TaxAmount) + Number(POCalcDetails.value.Transportcharges) + Number(POCalcDetails.value.Othercharges)) - Number(POCalcDetails.value.DiscountAmount)).toFixed(2)
            }

        }

        function POCalcDetailsClear() {
            debugger;
            POCalcDetails.value.GrossAmount = 0.00,
                POCalcDetails.value.TaxAmount = 0.00,
                POCalcDetails.value.SGSTTaxAmount = 0.00,
                POCalcDetails.value.CGSTTaxAmount = 0.00,
                POCalcDetails.value.IGSTTaxAmount = 0.00,
                POCalcDetails.value.ItemCount = 0,
                POCalcDetails.value.TotalAmount = 0.00
        }

        function TransportChargesOnChange() {
            debugger;
            POCalcDetails.value.Transportcharges = Number(POObj.value.TransportCharges).toFixed(2)
            poSubcalculation()
        }

        function OtherChargesOnChange() {
            debugger;
            POCalcDetails.value.Othercharges = Number(POObj.value.OtherCharges).toFixed(2)
            poSubcalculation()
        }

        function DiscountAmountOnChange() {
            debugger;
            POCalcDetails.value.DiscountAmount = Number(POObj.value.DiscountAmount).toFixed(2)
            poSubcalculation()
        }

        async function IsSubmit() {
            debugger;
            let response: any;
            let message = "";
            if (
                SupformData.value.SuplierAddress == "" ||
                SupformData.value.SuplierAddress == null ||
                SupformData.value.SuplierBillingAddress == "" ||
                SupformData.value.SuplierBillingAddress == null ||
                SupformData.value.SuplierDeliveryAddress == "" ||
                SupformData.value.SuplierDeliveryAddress == null ||
                POObj.value.PaymentTermsName == "" ||
                POObj.value.PaymentTermsName == null ||
                POObj.value.DeliveryTermsName == "" ||
                POObj.value.DeliveryTermsName == null
            ) {
                RequiredFieldFunction();
                return;
            }

            POObj.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            POObj.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            POObj.value.BranchId = session.BranchId;
            POObj.value.HospitalId = session.OrganizationId;
            POObj.value.ModifiedBy = session.UserId;
            POObj.value.CreatedBy = session.UserId;
            POObj.value.DocDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            POObj.value.EntityId = 3077;
            POObj.value.EntityOperationId = 3077001;
            POObj.value.DeptRoleId = rolesData.DeptRoleMapId;

            POObj.value.SupplierAddress = SupformData.value.SuplierAddress;
            POObj.value.BillingAddress = SupformData.value.SuplierBillingAddress;
            POObj.value.DeliveryAddress = SupformData.value.SuplierDeliveryAddress;

            POObj.value.Reference = SupformData.value.Reference;
            POObj.value.AdditionalTerms = SupformData.value.AdditionalTerms;
            POObj.value.IsDraft = 0;
            POObj.value.Id = POId;

            POObj.value.RefId = 0;

            POObj.value.TaxAmount = POCalcDetails.value.TaxAmount
            POObj.value.SGSTTaxAmount = POCalcDetails.value.SGSTTaxAmount
            POObj.value.CGSTTaxAmount = POCalcDetails.value.CGSTTaxAmount
            POObj.value.IGSTTaxAmount = POCalcDetails.value.IGSTTaxAmount
            POObj.value.Amount = POCalcDetails.value.TotalAmount

            POObj.value.DocType = "5";

            if (ItemTable.value.length == 0) {
                toast.add({
                    severity: "warn",
                    summary: "Couldn't send PO without Items",
                    detail: "",
                    life: 3000,
                });
                return;
            } else {

                const form = Object.assign(POObj.value);

                console.log(form);

                if (POId != 0) {
                    response = await WithoutStockService.updateStockWOTM(form);

                } else {
                    toast.add({
                        severity: "warn",
                        summary: "Somthing went wrong",
                        detail: "",
                        life: 3000,
                    });
                    return;
                }

                message = response["ErrorInfo"].ErrorCode;

                if (message == null) {
                    debugger;
                    for (let i = 0; i < ItemTable.value.length; i++) {
                        let obj = {};

                        (obj["Id"] = ItemTable.value[i]["StockDetailsId"]),
                            (obj["ItemId"] = ItemTable.value[i]["ItemId"]),
                            (obj["Qty"] = ItemTable.value[i]["ItemQuantity"]),
                            (obj["RefId"] = POId),
                            (obj["PackSizeId"] = ItemTable.value[i]["PackSizeId"]),
                            (obj["HSNId"] = ItemTable.value[i]["HSNId"]),
                            //(obj["TaxId"] = 1),
                            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                            (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                            // (obj["IsServiceLevel"] = consumeOrService),

                            (obj["CreatedBy"] = session.UserId),
                            (obj["ModifiedBy"] = session.UserId),
                            (obj["Rate"] = ItemTable.value[i]["Rate"]),
                            (obj["UnitRate"] = ItemTable.value[i]["UnitRate"]),
                            (obj["Description"] = ItemTable.value[i]["Description"]),
                            (obj["Brand"] =
                                ItemTable.value[i]["Brand"] == null
                                    ? 0
                                    : ItemTable.value[i]["Brand"]),
                            (obj["ModelNumber"] =
                                ItemTable.value[i]["ModelNumber"] == null
                                    ? 0
                                    : ItemTable.value[i]["ModelNumber"]),
                            (obj["Size"] =
                                ItemTable.value[i]["Size"] == null
                                    ? 0
                                    : ItemTable.value[i]["Size"]);

                        (obj["PurchaseTax"] = ItemTable.value[i]["PurchasePercentage"]),
                            (obj["PurchaseTaxAmount"] = ItemTable.value[i]["Purchasetaxamount"]),

                            (obj["SGSTTax"] = ItemTable.value[i]["SGSTTax"]),
                            (obj["SGSTTaxAmount"] = ItemTable.value[i]["SGSTTaxAmount"]),
                            (obj["CGSTTax"] = ItemTable.value[i]["CGSTTax"]),
                            (obj["CGSTTaxAmount"] = ItemTable.value[i]["CGSTTaxAmount"]),
                            (obj["IGSTTax"] = ItemTable.value[i]["IGSTTax"]),
                            (obj["IGSTTaxAmount"] = ItemTable.value[i]["IGSTTaxAmount"]),

                            (obj["Amount"] = ItemTable.value[i]["Amount"]),

                            (obj["Status"] = 1),

                            arr[i] = obj;
                    }

                    let result = await WithoutStockService.createStockWODetails(arr);

                    message = result["ErrorInfo"].ErrorCode;

                    if (message == null) {
                        await IsShowPOByPOId()
                        let nextTabIndex = selectedTab.value + 1;
                        if (nextTabIndex < SupplierInfo.value.length) {
                            SupplierOnClick(SupplierInfo.value[nextTabIndex], nextTabIndex);
                        }

                        const allIsDraft = HiddenItemTable.value.every(item => item.IsDraft === 0);
                        if (allIsDraft) {
                            successpop.value = true;
                            useConsigneePOStore.ConsigneePoIdList = [];
                            localStorage.removeItem("ConsigneePoIdList");
                        }

                        // updatepop.value = true;
                        // successpop.value = true;
                        //   PrintCrystalReport(id);
                    } else {
                        // successpop.value = true;
                        useConsigneePOStore.ConsigneePoIdList = []
                    }
                } else {
                    toast.add({
                        severity: "warn",
                        summary: "Somthing went wrong",
                        detail: "",
                        life: 3000,
                    });
                    return;
                }
            }
        }

        const EditSupplierAddressF = () => {
            debugger;

            RequiredFields.value.billingAddressHighlight = false;

            editSupplieraddress.value = !editSupplieraddress.value;

            const textarea = document.getElementById("billingTextarea");
            if (textarea) {
                textarea.focus();
            }
        };

        const EditBillAddress = () => {
            debugger;

            RequiredFields.value.billingAddressHighlight = false;

            editbillingaddress.value = !editbillingaddress.value;

            const textarea = document.getElementById("billingTextarea");
            if (textarea) {
                textarea.focus();
            }
        };

        const EditDeliveryAddress = () => {
            debugger;

            RequiredFields.value.deliveryAddressHighlight = false;

            editdeliaddress.value = !editdeliaddress.value;

            const textarea = document.getElementById("billingTextarea");
            if (textarea) {
                textarea.focus();
            }
        };

        const EditPaymentAndDeliveryTerms = () => {
            debugger;
            RequiredFields.value.paymentTermsHighlight = false;
            RequiredFields.value.deliveryTermsHighlight = false;

            editPaymentDeliveryDetails.value = !editPaymentDeliveryDetails.value;

            const textarea = document.getElementById("PaymentDeliveryTextarea");
            if (textarea) {
                textarea.focus();
            }
        };

        async function loadPaymentTerms() {
            debugger;
            try {
                const dataresponse = await PaymentTermsService.getdata();

                paymentTermsDropdown.value = dataresponse["result"].filter(
                    (item) =>
                        item.IsActive == true && item.HospitalId === session.OrganizationId
                ).map((item) => {
                    item.name = item.PaymentTermsDesc;
                    item.value = item.Id;
                    return item;
                });
            } catch (error) {
                console.log(error);
            }
        }

        async function loadDeliveryTerms() {
            debugger;
            try {
                const dataresponse = await DeliveryTermsService.getdata();

                deliveryTermsDropdown.value = dataresponse["result"].filter(
                    (item) =>
                        item.IsActive == true && item.HospitalId === session.OrganizationId
                ).map((item) => {
                    item.name = item.DeliTermsDesc;
                    item.value = item.Id;
                    return item;
                });
            } catch (error) {
                console.log(error);
            }
        }

        function PaymentTermsOnChange(value) {
            debugger;
            if (value != null) {
                let Paymentterms = paymentTermsDropdown.value.find(
                    (item) => item.value == value
                );

                POObj.value.PaymentTermsName = Paymentterms.name;
                RequiredFields.value.paymentTermsHighlight = false;
            } else {
                POObj.value.PaymentTermsName = "";
            }
        }

        function DeliveryTermsOnChange(value) {
            debugger;
            if (value != null) {
                let DeliveryTerms = deliveryTermsDropdown.value.find(
                    (item) => item.Id == value
                );

                POObj.value.DeliveryTermsName = DeliveryTerms.DeliTermsDesc;
                RequiredFields.value.deliveryTermsHighlight = false;
            } else {
                POObj.value.DeliveryTermsName = "";
            }
        }

        function closetrigger() {
            successpop.value = false;
            updatepop.value = false;
            setupHistoryManagement(router, 2);

            // router.back()


        }

        const copyGST = async () => {
            debugger;
            try {
                await navigator.clipboard.writeText(SupformData.value.SupplierGSTNO);
                console.log("Copied to clipboard:", SupformData.value.SupplierGSTNO);
                tooltipContent.value = "Copied!";
            } catch (error) {
                console.error("Failed to copy to clipboard");
            }
        };


        let supplierDetailsList = ref([])
        const visible: any = ref(false)
        const Iteminfoheaders = [


            {
                header: "Supplier Name",
                field: "POSupplierName",
                class: "smallwidth",
            },
            {
                header: "Last Purchase Date",
                field: "PurchaseDate",
                class: "smallwidth",
            },
            {
                header: "Store",
                field: "StoreName",
                class: "smallwidth",
            },

            {
                header: "Qty",
                field: "POQty",
                bodyclass: "right_td",
                class: "smallwidth",
            },
            {
                header: "Unit Rate",
                field: "UnitRate",
                bodyclass: "right_td",
                class: "smallwidth",
            },
            {
                header: "Rate",
                field: "Rate",
                bodyclass: "right_td",
                class: "smallwidth",
            },

            // {
            //   header: "Value",
            //   field: "TotalValue",
            //   // slot: "SizeIdLPO",
            //   bodyclass: "right_td",
            //   class: "smallwidth",
            // },


        ];

        async function getSupplierDetailsItemId(data) {
            try {
                // alert(JSON.stringify(ItemId))
                const result = await WithoutStockService.GetSupplierDetailsByItemId(data.ItemId, data.Brand, data.ModelNumber, data.Size, data.UOM);
                console.log(result);
                // alert(JSON.stringify(result["result"]))

                supplierDetailsList.value = result["result"];
            } catch (error) {
                console.log(error);
            }
        }

        const TempTaxOption = [
            { value: 5, name: '5%' },
            { value: 9, name: '9%' },
            { value: 12, name: '12%' },
            { value: 18, name: '18%' },
        ];


        function TempTaxOnChange(data) {
            debugger;

            data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

            if (data.SGSTTax && data.CGSTTax) {

                data.SGSTTax = Number(data.PurchasePercentage) / 2;

                data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

                data.CGSTTax = Number(data.PurchasePercentage) / 2;

                data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
            }

            if (data.IGSTTax) {
                data.CGSTTax = Number(data.PurchasePercentage) / 2;
                data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
            }

            data.Amount = Number((Number(data.Rate) - Number(data.DiscountAmount || 0)) + Number(data.Purchasetaxamount || 0)).toFixed(2)
        }

        return {
            SelectStore,
            Iteminfoheaders,
            visible,
            supplierDetailsList,
            getSupplierDetailsItemId,
            PoIdsList,
            useConsigneePOStore,
            tooltipContent,
            copyGST,
            POheaders,
            selectedProduct,
            label,
            ItemTable,
            SupplierInfo,
            SupplierOnClick,
            HiddenItemTable,
            POObj,
            SupformData,
            IsSubmit,
            updatepop,
            successpop,
            closetrigger,
            editSupplieraddress,
            EditSupplierAddressF,
            editbillingaddress,
            EditBillAddress,
            editdeliaddress,
            EditDeliveryAddress,
            paymentTermsDropdown,
            deliveryTermsDropdown,
            PaymentTermsOnChange,
            DeliveryTermsOnChange,
            editPaymentDeliveryDetails,
            EditPaymentAndDeliveryTerms,
            selectedTab,
            StoreDropdown,
            StoreOnChange,
            sumOfRates,
            RequiredFields,
            POCalcDetails,
            TransportChargesOnChange,
            OtherChargesOnChange,
            DiscountAmountOnChange,

            // temp tax changes
            TempTaxOption,
            TempTaxOnChange
        };
    },
});
</script>

<style lang="scss" scoped>
.highlight {
    border: 2px solid rgba(239, 142, 100, 0.564);
}

.totaldiv1 {
    background-color: #f7f7f9;
    padding: 10px;
    width: 100px;
    // height: 65px;
    border-radius: 5px;
    display: grid;
    place-items: center;
    margin-bottom: 10px;
}

.totaldiv2 {
    background-color: #eaecf1;
    padding: 10px;
    width: 120px;
    // height: 75px;
    border-radius: 5px;
    display: grid;
    place-items: center;
    margin-bottom: 10px;

}

.contentbg {
    background-color: #f5f5f5;
    padding: 10px;
    font-size: 14px;
    color: #999999;
}

.covertedstatus .lowstatus {
    padding: 10px 20px;
}

.servicelevel0 {
    color: #000000 !important;
}

.servicelevel1 {
    color: #FF5733 !important;
}

.servicelevel3 {
    color: #FFC300 !important;
}

.servicelevel4 {
    color: #520ed07d !important;
}

.servicelevel5 {
    color: #bd1ca5 !important;
}
</style>
<style lang="scss">
.suppliertabs {
    .card-header {
        background-color: #f9fbfc;
        border: 1px solid #e1e1e1;
        padding: 10px;
        border-radius: 5px;
        width: 100%;
        overflow: auto;

        .nav-link.active {
            background-color: #3096ff;
            //background-color: rgb(19, 171, 222);
            color: #ffffff;
        }

        .nav-link {
            color: #999999;
            white-space: nowrap;
        }

        .nav {
            flex-wrap: nowrap;
            width: 100%;
            overflow: auto;
        }

        .nav::-webkit-scrollbar {
            display: none;
        }
    }
}

.SupplierCard {
    // border: 1px solid #e1e1e1;
    // border-radius: 5px;
    background-color: #fff;
    // width: -webkit-fill-available;
    // margin: 0 15px 15px 15px;
}

.SupplierCardgst {
    background-color: rgb(250, 250, 250);
}

.SupplierCardgst .pi {
    display: none;
}

.SupplierCardgst:hover .pi {
    display: block;
}

.copyicon {
    cursor: pointer !important;
}

.suppliercardcontent .pi-external-link {
    display: none;
}

.suppliercardcontent:hover .pi-external-link {
    display: block;
}

.suppliercardcontent {
    .header {
        color: #999999;
    }

    .supplieraddress {
        color: #999999;
        font-size: 14px;
    }
}
</style>
